import { NewOrderPartyType } from "types/order";
import { PartyItem } from "../services";

export const orderPartiesAlphabetically = (party: PartyItem[]) => {
  return party.sort((partyA, partyB) => (
    (partyA.partyName || '').localeCompare(partyB.partyName || '')
    || (partyA.email || '').localeCompare(partyB.email || '')
  ));
};

export const partyMatchesQuery = (party: PartyItem, query: string): boolean => {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;

  return [party.partyName, party.email, ...(party.partyKinds ?? [])]
    .some((value) => (value ?? '').toLowerCase().includes(needle));
};

const MAX_PARTY_NAME_LENGTH = 40;

export const truncatePartyName = (partyName: string): string => (
  partyName.length > MAX_PARTY_NAME_LENGTH
    ? `${partyName.toString().substring(0, MAX_PARTY_NAME_LENGTH - 3)}...`
    : partyName
);

// Copies before sorting: the PartyItem role list is shared and must never be mutated.
export const formatPartyRoles = (partyKinds: string[]): string => (
  [...partyKinds].sort((a, b) => a.localeCompare(b)).join(', ')
);

export const formatAttendeeRoles = (kinds: string[] = []): string => (
  [...kinds].sort((a, b) => a.localeCompare(b)).join(' · ')
);

export const uniquePartiesById = (parties: PartyItem[]): PartyItem[] => {
  const seen = new Set<string>();
  return parties.filter((party) => {
    if (seen.has(party._id)) return false;
    seen.add(party._id);
    return true;
  });
};

export const convertToPartyItemArray = (parties: NewOrderPartyType[]) => {
  let partyList: PartyItem[] = [];

  parties.forEach((party) => {
    partyList = orderPartiesAlphabetically(partyList.concat(
      party.emails.map((email) => ({
        _id: email._id,
        partyId: party._id,
        partyName: party.name,
        email: email.address,
        emailKind: email.kind,
        partyKinds: party.kinds
      }))
    ));
  });

  return partyList;
};

export const buildPartyItemsFromEmails = (parties: NewOrderPartyType[], emails: string[]): PartyItem[] => {
  const partyList: PartyItem[] = [];
  emails.forEach((email) => {
    const party = parties.find((partyItem) => partyItem.emails.some(e => e.address === email));
    if (party) {
      partyList.push({
        _id: party.emails.find((e) => e.address === email)?._id!,
        partyId: party._id,
        partyName: party.name,
        email,
        emailKind: party.emails.find((e) => e.address === email)?.kind!,
        partyKinds: party.kinds
      });
    }
  });

  return partyList;
};